var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssigneeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.33,
    height: 27.328,
    viewBox: "0 0 27.33 27.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Assignee_icon",
    "data-name": "Assignee icon",
    d: "M12755,1217.414a13.415,13.415,0,1,1,13.414,13.414A13.414,13.414,0,0,1,12755,1217.414Zm19.544,4.636a8.957,8.957,0,0,1,2.3,3.958c.029-.027.056-.054.085-.082a12.039,12.039,0,1,0-17.233-.213,8.931,8.931,0,0,1,14.849-3.663Zm-11.158-9a4.842,4.842,0,1,1,4.842,4.84A4.841,4.841,0,0,1,12763.384,1213.054Z",
    transform: "translate(-12754.748 -1203.75)",
    fill: "#444141",
    stroke: "#444141",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigneeicon);
export default __webpack_public_path__ + "static/media/Assignee icon.d8195103e9cdfe1b7263287eb0b4c05e.svg";
export { ForwardRef as ReactComponent };